$().ready(function(){
  $('.sizebox').on('input',function(){
    var lgt = $('#lgt').val();
    var hgt = $('#hgt').val();
    var suit = "Suitable for Grids";
    var perc = (hgt/lgt)*100;
    var deg = (Math.atan(hgt/lgt))*(180/(Math.PI));
    $('#slopepercent').html(perc.toFixed(2));
    $('#flush').html(deg.toFixed(2));
    if(perc<=25.00){
      suit = 'Suitable for Grids';
    } else {
      suit = 'Not Suitable for Grids';
    }
    $('#suit').html(suit);
  })
  
})